import React, {FC} from "react"
import {CollectionName} from "../../../constants"
import VerticalSectionPlanFilters from "../../reusable/VerticalSectionPlanFilters"
import FilterDropdown from "../dropdown/FilterDropdown"
import PreviousFilters from "./PreviousFilters"

type Props = {
	filters: any[]
	productsPriceRange: any,
	collectionName: CollectionName
	collectionCategory?: string
	filteredProductsLength: number
	customUrlBaseValue?: string
	products?: any
}

const FilterVerticalSection:FC<Props> = ({filters, productsPriceRange, collectionName, collectionCategory = "", filteredProductsLength, customUrlBaseValue}) => {
	return (
		<div className="row">

			<PreviousFilters collectionName={collectionName}
				customUrlBaseValue={customUrlBaseValue} />

			<VerticalSectionPlanFilters collectionName={collectionName}
				productsPriceRange={productsPriceRange}
				customUrlBaseValue={customUrlBaseValue} />

			{
				!collectionCategory ? filters.map(attribute => {
					return (<div key={attribute.id}
						className={"px-0 border-bottom col-12"}>
						<FilterDropdown customUrlBaseValue={customUrlBaseValue}
							collectionName={collectionName}
							label={attribute.name}
							param={attribute.slug}
							options={attribute.terms || attribute.options}/>
					</div>)
				})					:
					filters.filter(attribute => attribute.name !== collectionCategory).map(attribute => {
						return (<div key={attribute.id}
							className={"px-0 col-12 border-bottom"}>
							<FilterDropdown customUrlBaseValue={customUrlBaseValue}
								collectionName={collectionName}
								label={attribute.name}
								param={attribute.slug}
								options={attribute.terms || attribute.options}/>
						</div>)
					})
			}
		</div>
	)
}

export default FilterVerticalSection
